<template>
  <router-link to="/login">
    <v-btn
      v-show="!isLoggedIn"
      class="hidden-sm-and-down"
      variants="text"
    >
      <v-icon
        class="mr-4"
        theme="dark"
        icon="fas fa-user"
      />
      Login
    </v-btn>
  </router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "LoginButton",
  props: {
    isLoggedIn: Boolean,
  },
});
</script>
